import React from 'react';

import './Destiny2PowerLevel.sass';
import {injectIntl} from 'react-intl';
import withMediaQueries from '../../../../containers/withMediaQueries/withMediaQueries';
import VariableStepRange from '../../../controls/variableStepRange/VariableStepRange';
import RestrictedNumberInput from '../../../controls/restrictedNumberInput/RestrictedNumberInput';

@injectIntl
@withMediaQueries({collapsed: '(max-width: 767px)'}, {collapsed: false})
export default class Destiny2PowerLevelPicker extends React.PureComponent {
  static describeRank = rank => rank.toString();

  static minValue = 1900;
  static maxValue = 2010;

  static getDefaultValue = () => [2000, 2010];

  static marks = {
    1900: 'Power Floor',
    1950: 'Soft Cap',
    2000: 'Powerful Cap',
    2010: 'Hard (Pinnacle) Cap',
  };

  render() {
    const {intl, collapsed, value, onChange} = this.props;

    return (
      <div>
        <div className="range-inputs">
          <div className="range-inputs__item">
            <RestrictedNumberInput
              label={intl.formatMessage({id: 'section.product.level'})}
              min={Destiny2PowerLevelPicker.minValue}
              max={Destiny2PowerLevelPicker.maxValue}
              value={value[0]}
              onChange={newValue => onChange([
                newValue,
                value[1]
              ])}
            />
          </div>

          <div className="range-inputs__divider"/>

          <div className="range-inputs__item">
            <RestrictedNumberInput
              label={intl.formatMessage({id: 'section.product.wanted'})}
              min={Destiny2PowerLevelPicker.minValue}
              max={Destiny2PowerLevelPicker.maxValue}
              value={value[1]}
              onChange={newValue => onChange([
                value[0],
                newValue
              ])}
            />
              </div>
            </div>

              {!collapsed && (
                <div className="slider">
                  <VariableStepRange
                    className="rc-slider-destiny-leveling"
                    step={1}
                    min={Destiny2PowerLevelPicker.minValue}
                    max={Destiny2PowerLevelPicker.maxValue}
                    marks={Destiny2PowerLevelPicker.marks}
                    value={value}
                    onChange={onChange}
                  />
                </div>
              )}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/productVariants/rankPickers/destiny2/Destiny2PowerLevel.js